/* jshint ignore:start */
var pageTimeline = '';
var heroTimeline = '';
var heroH1Timeline = '';
var portfolioScene = '';
//jQuery(document).ready(function () {
    var pageTimeline = new TimelineMax();
    var heroTimeline = new TimelineMax();
    var heroH1Timeline = new TimelineMax();
    var portfolioScene = new TimelineMax();
//});
var scenes = [];
var pjax_called = false; // Executes on page load.
var startTime = 0;
var current_scroll_location = '';
var cache_load = false;
main_nav_click = false;


// This function needs to be run on every pjax page load
function loadPage() {
    // Load background images
    jQuery('.load-bg-img').each(function (i, obj) {
        var large_img = jQuery(this).attr('data-bg-large');
        var small_img = jQuery(this).attr('data-bg-small');

        var item = jQuery(this);

        var bgImg = new Image();
        bgImg.onload = function () {
            item.css('background-image', 'url(' + bgImg.src + ')');
            item.addClass('loaded');
        };

        if (jQuery(document).width() > 1200) {
            bgImg.src = item.attr('data-bg');
        } else if (jQuery(document).width() > 992) {
            bgImg.src = item.attr('data-bg-small');
        } else {
            bgImg.src = item.attr('data-bg-tiny');
        }
    });

    // If we have a hero Image
    if (jQuery('.page-title').length) {

        jQuery('.page-title').imagesLoaded().progress(function () {
            jQuery(".page-title").addClass("inplace");

            setTimeout(function () {
                // Hero fade in
                var hero = jQuery(".page-title img.bg-img");
                heroTimeline
                    .fromTo(hero, 29, { scale: 1 }, { scale: 1.06, ease: Expo.easeOut })
                    .play();
            }, 200);
            

        });
    }

    load_portfolio_images();

    // Update theme mode.
    if (jQuery('html').hasClass('dark-mode')) {
        jQuery('.css-mode .mode-label').html('Dark mode');
        jQuery('.css-mode').attr('data-mode', 'dark');
    }
    else { 
        jQuery('.css-mode .mode-label').html('Light mode');
        jQuery('.css-mode').attr('data-mode', 'light');
    }

    // Register the events to control mode switcher
  jQuery(".css-mode").on("click", function (e) {
    var current_mode = jQuery(this).attr('data-mode');

    if (current_mode === 'dark') {
      jQuery(this).removeClass('dark');
      jQuery(this).addClass('light');
      jQuery(this).attr('data-mode', 'light');
      jQuery('.css-mode .mode-label').html('Light mode');
      jQuery('html').removeClass('dark-mode');
      // Set cookie
     createCookie("theme_mode", "light-mode", 14);

    }
    else { 
      jQuery(this).removeClass('light');
      jQuery(this).addClass('dark');
      jQuery(this).attr('data-mode', 'dark');
      jQuery('.css-mode .mode-label').html('Dark mode');
      jQuery('html').addClass('dark-mode');
      // Set cookie
      createCookie("theme_mode", "dark-mode", 14);
    }
    // If menu is open
    if (jQuery(".wrapper").hasClass('menu-open')) {
      setTimeout(function () {
        jQuery('.tcon').removeClass('tcon-transform');
        toggle_nav_menu();
      }, 100);
    }
  });
    
}


function triggerAnimationsPJAX() { 

     // If we have a hero Image
     if (jQuery('.page-title').length) {

        heroH1Timeline.kill();
        heroH1Timeline = new TimelineMax();

        var h1 = jQuery(".page-title h1");
        var cats = jQuery(".page-title .blog-cats");
        var sub = jQuery(".page-title .sub");
        heroH1Timeline
        .fromTo(h1, .8, { opacity: 0, y: 15 }, { delay: .5, opacity: 1, y: 0 })
        .fromTo(cats, .4, { opacity: 0 }, { delay: 0, opacity: 1 })
        .fromTo(sub, .5, { opacity: 0, y: 15 }, { delay: 0, opacity: 1, y: 0 })
        .play();
    }

}

function triggerAnimations() {


    //
    // Home page animations
    //
    if (jQuery(".intro h1").length > 0) {

          var controller = new ScrollMagic.Controller();
        
          var animateBackgroundWord = Array.prototype.slice.call(
            document.querySelectorAll(".intro")
          );
      
          animateBackgroundWord.forEach(function(self) {
            var text = self.querySelectorAll(".inner");
        
            var sceneOne = new TimelineMax();
        
            sceneOne.fromTo(text, 1, { opacity: 1 }, { opacity: 0 });
        
            var scene1 = new ScrollMagic.Scene({
              triggerElement: '.wrap',
              triggerHook: "onEnter",
              duration: 500,
              triggerHook: 0,
              offset: 50
            })
              .setTween(sceneOne)
              .setClassToggle(self, "active")
              .addTo(controller);
          });
        
        
    }

    //
    // Grid block fade in
    //
    if (jQuery(".m-grid").length > 0 && !cache_load) {

            // Pause for a bit before starting portfolio animations
            setTimeout(function () {
                
                if (portfolioScene != '') {
                    portfolioScene.kill();
                    portfolioScene = new TimelineMax();

                    var controller = new ScrollMagic.Controller();
                    var gridItems = jQuery(".m-grid .entry");

                    portfolioScene
                        .fromTo(gridItems, .25, { opacity: 0, x: 30 }, { opacity: 1, stagger: 0.15, x: 0 })
                        .play();

                    var smScenePortfolio = new ScrollMagic.Scene({
                        triggerElement: ".portfolio",
                        triggerHook: "onEnter",
                        duration: 0,
                        offset: '100px'
                    })
                        .setTween(portfolioScene)
                        .setClassToggle(self, "active")
                        .addTo(controller);

                }
                
            }, 10);

        
        // Hero fade in
        /*
        var gridItems = jQuery(".m-grid .entry");

        pageTimeline
            .fromTo(gridItems, .25, { opacity: 0, y: 20 }, { opacity: 1, stagger: 0.15, y: 0 })
            .play();
            */
    }


    //
    // Grid fade in
    //
    if (jQuery(".animate-grid-fadein").length > 0 && !cache_load) {
        // Hero fade in
        var gridItems = jQuery(".animate-grid-fadein .grid-item");

        pageTimeline
            .fromTo(gridItems, .4, { opacity: 0, y: 20 }, { opacity: 1, stagger: 0.15, y: 0 })
            .play();
    }




    if (jQuery(".grid-animate-scroll").length > 0 && !cache_load) {
        // Grid block fade in with images
        //jQuery('.grid-animate-scroll').imagesLoaded().progress(function () {
        var gridBlock = jQuery(".grid-animate-scroll .grid-item");
        var gridBlockScene = new TimelineMax();

        gridBlockScene.fromTo(
            gridBlock,
            0.6,
            { opacity: 0, y: 20 },
            { delay: 1, opacity: 1, y: 0, stagger: 0.2 }
        );

        var gbScene = new ScrollMagic.Scene({
            triggerElement: ".grid-animate-scroll",
            triggerHook: "onEnter",
            duration: 0,
            //offset: 150
        });

        //});
    }



    if (jQuery(".section-fade-scroll").length > 0 && !cache_load) {
        // Grid block fade in with images
        //jQuery('.grid-animate-scroll').imagesLoaded().progress(function () {
        var sectionFadeScrollBlock = jQuery(".section-fade-scroll");
        var sectionFadeScrollScene = new TimelineMax();

        sectionFadeScrollScene.fromTo(
            sectionFadeScrollBlock,
            0.6,
            { opacity: 0 },
            { delay: 2, opacity: 1 }
        );

        var gbScene = new ScrollMagic.Scene({
            triggerElement: ".section-fade-scroll",
            triggerHook: "onEnter",
            duration: 0,
            //offset: 150
        });

        //});
    }



}


function displayBackLink(url) {
    if (url !== undefined) {
        var pieces = url.split('/');
        slug = pieces[3];
        //console.log(pieces);
        if (slug == 'work' && pieces[4] != undefined && pieces[4] != '') {
            jQuery('.back-link').html('&larr; View all work');
            jQuery('.back-link').attr('href', '/work/');
            jQuery('.back-link').addClass('show');
        }
        else if (slug == 'blog' && pieces[4] != undefined && pieces[4] != '') {
            jQuery('.back-link').html('&larr; View all blogs');
            jQuery('.back-link').attr('href', '/blog/');
            jQuery('.back-link').addClass('show');
        }
        else if (slug == 'services' && pieces[4] != undefined && pieces[4] != '') {
            jQuery('.back-link').html('&larr; View all services');
            jQuery('.back-link').attr('href', '/services/');
            jQuery('.back-link').addClass('show');
        }
        else if (slug == 'studio' && pieces[4] != undefined && pieces[4] != '') {
            jQuery('.back-link').html('&larr; Back to studio');
            jQuery('.back-link').attr('href', '/studio/');
            jQuery('.back-link').addClass('show');
        }
        else {
            jQuery('.back-link').removeClass('show');
        }
    }
}




var load_start_time = new Date();

jQuery(document).ready(function () {

    loadPage();

    load_end_time = new Date();
    var load_time = load_end_time - load_start_time; //in ms

    triggerAnimations();
    
    /*
    // If we're less than 700 ms, add some pause time.
    var pause_time = 10;
    if (load_time < 500) {
        pause_time = 700;
    }

    setTimeout(function () {
        jQuery(".loader").addClass("hiding");
        triggerAnimations();
    }, pause_time);
    setTimeout(function () {
        jQuery(".loader").addClass("hide");
    }, pause_time + 200);
    */

    // Add back link.
    displayBackLink(window.location.href);


    //
    // Start pjax for all links
    //
    //jQuery(document).pjax("a:not('[no-data-pjax]')", '#pjh', {
    //jQuery(document).pjax("a:not([href='/contact/'])", '#pjh', {
    jQuery(document).pjax("a:not([href='/contact/'])", '#pjax-content', {
        scrollTo: false,
        maxCacheLength: 1,
        timeout: 7000
    });
    

    jQuery('#pjax-content').on('pjax:complete', function (xhr, textStatus, options) {
        //console.log('PJAX Complete.');
        pjax_called = true; // Prevent the reload
    });



    jQuery('#pjax-content').on('pjax:click', function (xhr, options) {
        if (startTime == 0) {
            pjaxBeforeSend();
        }
    });

    jQuery('#pjax-content').on('pjax:beforeSend', function (xhr, options) {
        if (startTime == 0) {
            pjaxBeforeSend();
        }
    });




    jQuery('#pjax-content').on('pjax:beforeReplace', function (xhr, textStatus, options) {
        endTime = new Date();
        var timeDiff = endTime - startTime; //in ms

        //console.log(timeDiff + " miliseconds to get to beforeReplace");
        //console.log(options);
        //console.log(textStatus);


        // Sleep if this wasn't called from the main nav.
        if (!main_nav_click) {
            //console.log("Sleeping");
            time_to_sleep = 300 - timeDiff;
            if (time_to_sleep > 0) {
                //console.log('Sleeping for ' + time_to_sleep);
                sleepSync(time_to_sleep);
            }
            //console.log("Woke up");
        }
        
    });



    jQuery('#pjax-content').on('pjax:end', function (xhr, textStatus, options) {

        endTime = new Date();
        var timeDiff = endTime - startTime; //in ms


        time_to_sleep = 200 - timeDiff;
        if (time_to_sleep <= 0) { 
            time_to_sleep = 0;
        }

        // Reset start time
        startTime = 0;

        //console.log('Response recieved and we are sleeping for' + time_to_sleep);

        // Set a time out if we need to.
        setTimeout(function () {

        //if (!pjax_called) {
            //window.location.reload();
        //}
         pjax_called = false; // reset

        //var non_blog_slugs = ['services', 'work', 'process', 'studio', 'shop', 'contact', '']

        //
        // Get the slug from the URI
        //
        var slug = '';
        is_work_subpage = '';
        if (typeof options.url !== 'undefined') {
            var pieces = options.url.split('/');
            slug = pieces[3];

            if (slug == 'work' && pieces[4] != 'undefined') {
                is_work_subpage = true;
            }
        }

        displayBackLink(options.url);



        if (typeof (pjaxy_page_info) !== 'undefined') {
            jQuery('head title').html(pjaxy_page_info.page_title);

            jQuery('meta[property=og\\:title]').attr('content', pjaxy_page_info.page_title);
            jQuery('meta[property=twitter\\:title]').attr('content', pjaxy_page_info.page_title);

            jQuery('meta[property=og\\:description]').attr('content', pjaxy_page_info.page_desc);
            jQuery('meta[property=twitter\\:description]').attr('content', pjaxy_page_info.page_desc);

            jQuery('meta[property=og\\:url]').attr('content', options.url);


            // Set the body class
            if (pjaxy_page_info.body_class != '') {
                jQuery('body').attr('class', pjaxy_page_info.body_class + ' pjax-processing gone');
                console.log('Setting new body class');
            }

            // If we're using a hero image, add the hero class to the html element
            if (pjaxy_page_info.use_hero) {
                setTimeout(function () {
                    jQuery('html').addClass('hero');
                }, 10);
            }
            else {
                setTimeout(function () {
                    jQuery('html').removeClass('hero');
                }, 10);
            }

        }
        else {
            //console.log('pjax is not defined');
        }




        //
        // Do some things if we're using mouseflow
        //
        if (0 && using_mouseflow) {

            window._mfq = window._mfq || [];

            // When a new virtual page is rendered
            window._mfq.push(["newPageView"]);
        }





        //
        // Remove the processing class
        //
        setTimeout(function () {
            jQuery('body').removeClass('gone');
            //jQuery("#pjax-content").html(jQuery("#pjh").html());
            jQuery("#pjh").html("");

            setTimeout(function () {
                initiateMixedJS();
            }, 2);


            //
            // Scroll to the top
            //
            cache_load = false;
            if (jQuery('#data-scroll').length > 0) {
                cache_load = true;
                var scroll_location = jQuery('#data-scroll').attr('data-scroll');
                if (scroll_location > 0) {
                    jQuery('html, body').scrollTop(scroll_location);
                    jQuery('#data-scroll').attr('data-scroll', '0');
                }
            }
            else {
                jQuery(window).scrollTop(0);
            }

            setTimeout(function () {
                jQuery(".loader").addClass("hiding");
            }, 100);
            setTimeout(function () {
                jQuery(".loader").addClass("hide");
            }, 110);



            //
            // Initiate stuff
            //
            loadPage();


            setTimeout(function () {
                triggerAnimationsPJAX();
                triggerAnimations();
            }, 3);



        }, 200);




        setTimeout(function () {
            jQuery('body').removeClass('pjax-processing');

            // Send the page view to Google.
            if (document.location.hostname !== "localhost") {
                //ga('set', 'location', window.location.href);
                //ga('send', 'pageview');
            }
        }, 220);




        //
        // If this is a blog page view, include twitter javascript for embedding tweets
        //
        /*
        setTimeout(function () {
            if (typeof (pjaxy_page_info) !== 'undefined') {
                //if (pjaxy_page_info.is_single) {
                //    twttr.widgets.load();
                //}
            }
        }, 230);
        */
        
            if (!cache_load) {
                jQuery('.work-section .entry').addClass('inplace');
            }
        
        }, time_to_sleep);

    });
});


jQuery(document).ready(function () {
    initiateMixedJS();
    //console.log('Starting JS');
});
  
function initiateMixedJS() {
    jQuery(".masonry-grid").each(function () {
  
        var origin_left = true;
        if (jQuery(this).attr('data-origin-left') == 'true') {
          origin_left = false;
        }
        else {
          origin_left = true;
        }
    
        // Portfolio masonry layout
        var $grid = jQuery(this).masonry({
          // options
          itemSelector: ".grid-item",
          percentPosition: true,
          columnWidth: ".grid-sizer",
          horizontalOrder: false,
          originLeft: origin_left
        });
    
        // layout Masonry after each image loads
        $grid.imagesLoaded().progress(function () {
          $grid.masonry("layout");
        });
      
        //jQuery(".m-grid").featherlightGallery();
        
    });
    


    const swiper = new Swiper('.swiper-container', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
    
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        breakpoints: {
          10: {
            slidesPerView: 1.3,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1100: {
            slidesPerView: 3,
            spaceBetween: 50,
            },
          1600: {
            slidesPerView: 4,
            spaceBetween: 50,
           },
        },
      
        // If we need pagination
        //pagination: {
        //  el: '.swiper-pagination',
        //},
      
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      
        // And if we need scrollbar
        //scrollbar: {
        //  el: '.swiper-scrollbar',
        //},
    });
    


    // Flexible content slider
    jQuery('.slider:not(.logo-slider, .logo-slider-grid) .swiper').each(function (i, obj) {
        var swiper_id = jQuery(this).attr('id');
        const swiper2 = new Swiper("#" + swiper_id, {
            // Optional parameters
            direction: 'horizontal',
            spaceBetween: 40,
            loop: true,
            centeredSlides: false,
            slidesPerView: 1.1,
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                10: {
                  slidesPerView: 1.1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 1.1,
                  spaceBetween: 40,
                },
                800: {
                  slidesPerView: 1,
                  spaceBetween: 50,
                 },
              },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            autoplay: {
                delay: 7000,
            },
        });
    });

    // Logo slider
    jQuery('.slider.logo-slider .swiper').each(function (i, obj) {
        var swiper_id = jQuery(this).attr('id');
        const swiper3 = new Swiper("#" + swiper_id, {
            // Optional parameters
            direction: 'horizontal',
            spaceBetween: 40,
            loop: true,
            centeredSlides: false,
            slidesPerView: 2,
            breakpoints: {
                600: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
                780: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
                820: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
                1300: {
                  slidesPerView: 5,
                  spaceBetween: 15,
              },
              1600: {
                slidesPerView: 6,
                spaceBetween: 15,
              },
              },
            autoplay: {
                delay: 3000,
            },
        });
    });

    // Logo slider grid
    jQuery('.slider.logo-slider-grid .swiper').each(function (i, obj) {
        var swiper_id = jQuery(this).attr('id');
        const swiper4 = new Swiper("#" + swiper_id, {
            // Optional parameters
            direction: 'horizontal',
            spaceBetween: 40,
            loop: true,
            centeredSlides: false,
            slidesPerView: 2,
            grid: {
                rows: 2,
            },
            breakpoints: {
                50: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                    grid: {
                        rows: 2,
                    },
                },
                780: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                    grid: {
                        rows: 2,
                    },
                },
                820: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                    grid: {
                        rows: 2,
                    },
                },
                1300: {
                  slidesPerView: 5,
                    spaceBetween: 15,
                    grid: {
                        rows: 2,
                    },
              },
              1600: {
                slidesPerView: 6,
                  spaceBetween: 15,
                  grid: {
                    rows: 2,
                },
              },
              },
            autoplay: {
                delay: 2500,
            },
        });
    });

    



}

function pjaxBeforeSend() { 

    /*
    const videos = document.querySelectorAll('video');
    for (let i = 0; i < videos.length; i++) {
        videos[i].pause();
        videos[i].removeAttribute('src');
        videos[i].load();
        console.log('Destroyed a video.');
    }
    */

    // Save the scrolling location.
    current_scroll_location = jQuery(window).scrollTop();
    // Save to DOM for this page view.
    var scroll_location = jQuery('#data-scroll').attr('data-scroll');
    if (jQuery('#data-scroll').length > 0) {
        jQuery('#data-scroll').attr('data-scroll', '0');
    }
    else {
        jQuery('#pjax-content').append('<div id="data-scroll"  data-scroll="' + current_scroll_location + '"></div>');
    }

    setTimeout(function () {
        const videos = document.querySelectorAll('video');
        for (var i = 0; i < videos.length; i++) {
            //videos[i].pause();
            videos[i].remove();
            //console.log('Removed video');
        }
    }, 5);

    

    if (jQuery('.wrapper').hasClass('menu-open')) {
        main_nav_click = true;
    }
    else { 
        main_nav_click = false;
    }

    setTimeout(function () {
        jQuery(".wrapper").removeClass("menu-blur");
        setTimeout(function () {
            jQuery(".wrapper").removeClass("menu-open");
        }, 100);
        jQuery('.tcon').removeClass('tcon-transform');
    }, 100);
    
    startTime = new Date();

    //console.log('INIT BEFORE PJAX');

    if (!jQuery('body').hasClass('pjax-processing')) {
        jQuery('body').addClass('pjax-processing');
        jQuery('body').addClass('gone');
        //console.log('---------- Set body class');
    }

    if (typeof portfolioScene !== 'undefined') {
        portfolioScene.reverse();
    }

    //pageTimeline.reverse();
    //heroH1Timeline.reverse();
    headroom.pin();

    setTimeout(function () {
        pageTimeline.kill();
        pageTimeline = new TimelineMax();
        heroTimeline.kill();
        heroTimeline = new TimelineMax();
        heroH1Timeline.kill();
        heroH1Timeline = new TimelineMax();
        if (typeof gridBlockScene !== 'undefined') {
            gridBlockScene.kill();
            gridBlockScene = new TimelineMax();
        }
        if (typeof sectionFadeScrollScene !== 'undefined') {
            sectionFadeScrollScene.kill();
            sectionFadeScrollScene = new TimelineMax();
        }
        if (typeof portfolioScene !== 'undefined') {
            portfolioScene.kill();
            portfolioScene = new TimelineMax();
        }
    }, 400);
}